import React, {useState} from 'react';
import classNames from 'classnames';
import '../styles/board.scss';
import {Popover} from 'react-tiny-popover';
import {hmToString, minsToHM} from '../utils/mins-to-time';
import {SecProgressBar} from './sec-progress-bar';

const ALL_MINUTES = 60 * 24; // 1440

export function Board({date}: {date: Date}): React.ReactElement {
  const [popupTime, setPopupTime] = useState<null | string>(null);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const currentHourInMinutes = hours * 60;
  const currentFullMinutes = currentHourInMinutes + minutes;
  const nextHourInMinutes = Math.min((hours + 1) * 60, ALL_MINUTES);

  return (
    <div className="board">
      {Array.from({length: ALL_MINUTES}).map((_, min) => {
        const upcomingMinute = currentFullMinutes + 1 === min;
        const isUpcomingMinute = min > currentFullMinutes && min < nextHourInMinutes;
        const hasLabel = isUpcomingMinute && min % 5 === 0;
        const hm = minsToHM(min);
        const timeString = hmToString(hm);

        if (popupTime === timeString) {
          return (
            <Popover
              isOpen
              positions={['right', 'left']}
              key={timeString}
              content={
                <div
                  className="bg-gray-50 p-2 drop-shadow-xl rounded-md text-sm cursor-pointer"
                  onClick={() => alert('The feature is in development. Subscribe to get updates!')}
                  role="menu"
                >
                  <div className="hover:bg-gray-200 p-1">Add event</div>
                  <div className="hover:bg-gray-200 p-1">New ToDo</div>
                </div>
              }
            >
              <div
                data-h={hm.h}
                data-m={hm.m}
                className={classNames('m', {
                  current: upcomingMinute,
                  s: true,
                  h: min > currentFullMinutes,
                  b: min <= currentFullMinutes,
                })}
                onClick={() => setPopupTime(timeString)}
                role="gridcell"
              >
                {upcomingMinute && <SecProgressBar seconds={seconds} />}
                {hasLabel && <span className="label">{hm.m}</span>}
              </div>
            </Popover>
          );
        }

        return (
          <div
            data-h={hm.h}
            data-m={hm.m}
            className={classNames('m', {
              current: upcomingMinute,
              h: min > currentFullMinutes,
              b: min <= currentFullMinutes,
            })}
            key={timeString}
            onClick={() => setPopupTime((cur) => (cur ? null : timeString))}
            role="gridcell"
          >
            {upcomingMinute && <SecProgressBar seconds={seconds} />}
            {hasLabel && <span className="label">{hm.m}</span>}
          </div>
        );
      })}
    </div>
  );
}
